export default __webpack_public_path__ + "static/media/mobile.9c3f077d.svg";